import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '@artemis/integrations/contentful/utils';

const MerchantStateLabel = ({ label = '', todaysHours = '' }) => {
  switch (label) {
    case 'merchantState.unavailable':
      return <FormattedMessage entry="merchantState.temporarilyUnavailable" />;
    case 'merchantState.busyShort':
      return <FormattedMessage entry="merchantState.busy" />;
    case 'merchantState.closedShort':
      return (
        <>
          <FormattedMessage entry="merchantState.closedShort" /> - {todaysHours}
        </>
      );
    default:
      return todaysHours;
  }
};

MerchantStateLabel.propTypes = {
  label: PropTypes.string,
  todaysHours: PropTypes.string,
};

export default MerchantStateLabel;
